import classNames from 'classnames';
import { forwardRef } from 'react';
import { LeftRightEmptyStateContainer } from '../left_right';
import { DisableInteraction } from './disable_interaction';
const containerCss = "c14d26dv";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const PreviewEmptyState = ({
  contentKey,
  featureKey,
  children
}) => <Container data-testid="empty-state-preview">
    <LeftRightEmptyStateContainer contentKey={contentKey} featureKey={featureKey} border preview />
    <DisableInteraction>{children}</DisableInteraction>
  </Container>;

require("./preview_empty_state.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./preview_empty_state.js");